export default __webpack_public_path__ + "static/media/empty-sprint-chart.be34744d.svg";